import { render, staticRenderFns } from "./carddata.vue?vue&type=template&id=6d7e90ec&scoped=true&"
import script from "./carddata.vue?vue&type=script&lang=js&"
export * from "./carddata.vue?vue&type=script&lang=js&"
import style0 from "./carddata.vue?vue&type=style&index=0&id=6d7e90ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7e90ec",
  null
  
)

export default component.exports